import styled from 'styled-components';

export const StyledPaymentsAndInvoicesIcon = styled.div`
   > svg {
      width: 20px;
      height: 20px;
   }
`;
StyledPaymentsAndInvoicesIcon.displayName = 'StyledPaymentsAndInvoicesIcon';
